<template>
  
    <div class="contenedor pt-1">
        <div class="d-flex justify-content-between">
            <h4 class="pl-3 mb-3"><i class="icon-location3 mr-2"></i>DIRECCIONES</h4>
            <!-- <button class="cerrar mb-2" @click="cerrar()">X</button> -->
        </div>    
        
        <div class="direcciones">
            <div class="direc pb-2" v-for="(direccion,pos) in vDirecciones" :key="pos">
            <div class="ml-3 mr-3" :class="{'activo': pos==posicion}">
                <div class="d-flex flex-column mb-3 nombre">
                    <span>Nombre</span>
                    <p v-if="pos!=posicion">{{ direccion.mscdNombre }}</p>
                    <input type="text" v-else name="nombre" ref="nombre" v-model='vNombre'/>
                </div>    
                <div class="d-flex flex-column mb-3 direcc">
                    <span>Dirección</span>
                    <p v-if="pos!=posicion">{{ direccion.mscdCalle }}</p>
                    <input type="text" v-else name="direc" ref="direccion" v-model='vCalle'/>
                </div>   
                <div class="d-flex flex-column mb-3 codigo"> 
                    <span>CP</span>
                    <p v-if="pos!=posicion">{{ direccion.mscdCp }}</p>
                    <input type="text" v-else name="codigo" ref="codigo" v-model='vCp'>
                </div>   
                <div class="d-flex flex-column mb-3 pais">
                    <span>País</span>
                    <p v-if="pos!=posicion">{{ direccion.pais.mspaisnomesp }}</p>
                    <select
                        ref='ipais'
                        class='form-control form-control-sm'
                        v-model='vPais'
                        v-else
                        @change='getProvinciasByPais()'>
                        <option v-for='pais in paises' :key='pais.mspaisid' :value='{ id: pais.mspaisid, text: pais.mspaisnomesp }'>
                        {{ pais.mspaisnomesp }}
                        </option>
                    </select>
                </div>
                <div class="d-flex flex-column mb-3 provincia">
                    <span>Provincia</span>
                    <p v-if="pos!=posicion">{{ direccion.provincia.msprovincianomesp }}</p>
                    <select
                        ref='iprovincia'
                        class='form-control form-control-sm'
                        v-model='vProvincia'
                        v-else
                        >
                        <option v-for='provincia in provincias' :key='provincia.msprovinciaid' :value='{ id: provincia.msprovinciaid, text: provincia.msprovincianomesp }'>
                        {{ provincia.msprovincianomesp }}
                        </option>
                    </select>
                </div> 
                    <div class="d-flex flex-column mb-3 ciudad">
                    <span>Ciudad</span>
                    <p v-if="pos!=posicion">{{ direccion.mscdPoblacion }}</p>
                    <input type="text" v-else name="ciudad" ref="ciudad" v-model='vCiudad'/>
                </div>   
                <div>
                    <div class="" v-if="modificar && posicion == pos">
                        <button @click="guardarDirec()"><img class="ml-1 mb-3" src="@/assets/css/icons/flaticon/floppy-disk.svg" width="25" height="25" /></button> 
                        <button class="ml-3 cerrar" @click="cancelar(pos)">X</button>
                    </div>
                    <div v-else>
                        <button @click="modificarDirec(pos)" :disabled="deshabilitar"><img class="ml-2" src="@/assets/css/icons/flaticon/edit.svg" width="18" height="20" /></button>
                        <button @click="borrarDirec(pos)" :disabled="deshabilitar"><img class="ml-2" src="@/assets/css/icons/flaticon/trash-bucket.svg" width="18" height="20" /></button>    
                    </div>       
                </div>   
            </div>    
            </div> 
            <button class="anadir mt-2" @click="anadirDir()" :disabled="deshabilitar"><img class="mr-2" src="@/assets/css/icons/flaticon/plus.svg" width="13" height="13" />Añadir dirección</button>
        </div>    
    </div>    
</template>
<script>
import { PaisApiService } from '@/api/PaisApiService'
import { ProvinciaApiService } from '@/api/ProvinciaApiService'
import { Util } from '@/api/Util'
import { ClienteDireccionesApiService } from '@/api/ClienteDireccionesApiService';

const clienteDireccionesApi = new ClienteDireccionesApiService()
const paisApiService = new PaisApiService()
const provinciaApiService = new ProvinciaApiService()
const util = new Util()
export default{
    props: {
        direcciones: { type: Array, required: true }
    },
    data() {
        return {
            modificar: false,
            posicion: -1,
            deshabilitar: false,
            paises: [],
            provincias: [],
            vPais: '',
            vProvincia: '',
            vNombre: '',
            vCalle: '',
            vCp: '',
            vCiudad: '',
            vId: '',
            nDirecciones: 0,
            vDirecciones: []
        }
    },
    created() {
        this.nDirecciones = this.direcciones.length
        this.vDirecciones = this.direcciones
        this.init()
    },
    methods: {
        init() {
            this.getAllPais()
        },
        modificarDirec(posicion){
            this.vPais = { id: this.vDirecciones[posicion].pais.mspaisid,
                           text: this.vDirecciones[posicion].pais.mspaisnomesp
                         }
            this.getProvinciasByPais ()
            this.vProvincia = { id: this.vDirecciones[posicion].provincia.msprovinciaid,
                                text: this.vDirecciones[posicion].provincia.msprovincianomesp
                              } 
            this.vNombre = this.vDirecciones[posicion].mscdNombre
            this.vCalle = this.vDirecciones[posicion].mscdCalle
            this.vCiudad = this.vDirecciones[posicion].mscdPoblacion
            this.vCp = this.vDirecciones[posicion].mscdCp
            this.vId = this.vDirecciones[posicion].mscdId
            this.modificar = true;
            this.posicion = posicion;
        },
        guardarDirec(){
            if (this.isValidForm()) {
                let direccion = {
                    mscdNombre: this.vNombre,
                    mscdCalle: this.vCalle,
                    mscdCp: this.vCp,
                    mscdPoblacion: this.vCiudad,
                    provincia: { 
                        msprovinciaid: this.vProvincia.id,
                        msprovincianomesp: this.vProvincia.text
                    },
                    pais:{
                        mspaisid: this.vPais.id,
                        mspaisnomesp: this.vPais.text
                    },
                    mscdClienteUid: this.$store.getters.getCliente.uid
                }
                if (this.vId !== '') {
                    direccion.mscdId = this.vId
                    clienteDireccionesApi.updateDireccionCliente(direccion)
                        .then(data => {
                            this.vDirecciones[this.posicion] = data.data
                            this.modificar = false;
                            this.posicion = -1;
                            this.deshabilitar = false;
                            
                        })
                        .catch(error => {
                            console.log(error)
                            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
                        })
                } else {
                    clienteDireccionesApi.guardarDireccionCliente(direccion)
                        .then(data => {
                            this.vDirecciones[this.posicion] = data
                            this.modificar = false;
                            this.posicion = -1;
                            this.deshabilitar = false; 
                            this.nDirecciones = this.vDirecciones.length
                        })
                        .catch(error => {
                            console.log(error)
                            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
                        })
                }
               
            }
            
        },
        anadirDir(){
            this.vNombre = ''
            this.vCalle = ''
            this.vCp = ''
            this.vPais = ''
            this.vProvincia = ''
            this.vCiudad = ''
            this.vId = ''
            this.vDirecciones.push("");
            this.modificar = true;
            this.deshabilitar = true;
            this.posicion = this.vDirecciones.length -1;
        },
        borrarDirec(posic){
            this.$root.$confirm.open('Borrar', '¿Deseas eliminar esta direccion?', { color: 'primary' }).then((confirm) => {
                if(confirm)
                {
                    clienteDireccionesApi.borrarDireccionCliente(this.vDirecciones[posic].mscdId)
                        .then(data => {
                            this.vDirecciones.splice(posic,1); 
                        })
                        .catch(error => {
                            console.log(error)
                            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
                        })
                }
            })
        },
        getPaisLit (codPais) {
            if (codPais) {
                return this.paises.filter(pais => pais.mspaisid==codPais)[0].mspaisnomesp
            }
        },
        getProvinciaLit (codProvincia) {
            if (codProvincia) {
                return this.provincias.filter(provincia => provincia.msprovinciaid==codProvincia)[0].msprovincianomesp
            }
        },
        getAllPais () {            
            paisApiService.getAllPais()
                .then(data => {
                    this.paises = data
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getProvinciasByPais () {
            if(this.vPais !== '') {
                provinciaApiService.getProvinciasByPais(this.vPais.id)
                    .then(data => {
                        this.provincias = data
                    })
                    .catch(error => {
                    console.log(error)
                    })
            }
        },
        cancelar(pos) {
            if (pos === this.nDirecciones) {
                this.vDirecciones.splice(pos,1);
                this.deshabilitar = false;
                this.vPais = '';
                this.vProvincia = '';
            }
            this.posicion = -1
            this.vId = ''
        },
        isValidForm() {
            let valido = true
            if (util.isEmptyField(this.vNombre)) {
                this.$refs['nombre'][0].classList.value += ' is-invalid'
                valido = false
            } else {
                this.$refs['nombre'][0].classList.value = this.$refs['nombre'][0].classList.value.replace(' is-invalid','')
            }   
            if (util.isEmptyField(this.vCalle)) {
                this.$refs['direccion'][0].classList.value += ' is-invalid'
                valido = false
            } else {
                this.$refs['direccion'][0].classList.value = this.$refs['direccion'][0].classList.value.replace(' is-invalid','')
            }   
            if (util.isEmptyField(this.vCp)) {
                this.$refs['codigo'][0].classList.value += ' is-invalid'
                valido = false
            } else {
                this.$refs['codigo'][0].classList.value = this.$refs['codigo'][0].classList.value.replace(' is-invalid','')
            }   
            if (util.isEmptyField(this.vPais)) {
                this.$refs['ipais'][0].classList.value += ' is-invalid'
                valido = false
            } else {
                this.$refs['ipais'][0].classList.value = this.$refs['ipais'][0].classList.value.replace(' is-invalid','')
            }   
            if (util.isEmptyField(this.vProvincia)) {
                this.$refs['iprovincia'][0].classList.value += ' is-invalid'
                valido = false
            } else {
                this.$refs['iprovincia'][0].classList.value = this.$refs['iprovincia'][0].classList.value.replace(' is-invalid','')
            }   
            if (util.isEmptyField(this.vCiudad)) {
                this.$refs['ciudad'][0].classList.value += ' is-invalid'
                valido = false
            } else {
                this.$refs['ciudad'][0].classList.value = this.$refs['ciudad'][0].classList.value.replace(' is-invalid','')
            }   
            return valido
        },
        cerrar() {
            if (this.posicion !== this.nDirecciones) {
                this.$emit('close')
            } else {
                this.cancelar(this.nDirecciones)
                this.$emit('close')
            }
        }
    },
}
</script>
<style scoped>
    .contenedor{
        background-color: white;
        width: 790px;
        margin: 0 auto;
    }

    .icon-location3{
       font-size: 22px;
       padding-bottom: 8px;
    }

    h4{
        font-weight: bold;
        width: 80%;
    }

    .cerrar {
        color: #27629D;
        font-size: 18px;
    }

    .direc > div{
        border-bottom: 1px solid #C8CBCC;
        display: flex;
        flex-wrap: wrap;
    }

    .direc > div > div{
        margin-right: 10px;
    }

    span{
        color: #C8CBCC;
    }

    .anadir{
        background-color: #27629D;
        color: white;
        border-radius: 20px;
        padding: 7px;
        padding-left: 15px;
        padding-right: 15px;
        margin-left: 615px;
        margin-bottom: 15px;
    }

    .anadir img{
        margin-top: -1px;
    }

    button img{
        margin-top: 20px;
    }

    .activo input{
        background-color: rgba(39,98,157,0.2);
        padding-left: 7px;
        border-radius: 10px;
        pointer-events: all;
    }

    .activo span{
        color: #27629D;
    }

    input{
        pointer-events: none;
    }

    .nombre{
        width: 105px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .direcc{
        width: 160px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .pais{
        width: 100px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .provincia{
        width: 100px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .codigo {
        width: 65px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .ciudad{
        width: 100px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

 @media (max-width:655px){
     .contenedor{
         width: 600px;
     }

     .nombre{
         width: 90px;
     }

     .direcc{
         width: 140px;
     }

     .anadir{
         margin-left: 440px;
     }
 }   
</style>